/* One product allowlist is enforced by Liquid; no catalog or discount writes. */
(() => {
  const money = cents => new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(cents / 100);
  function init(root) {
    if (root.dataset.tlInitialized) return;
    root.dataset.tlInitialized = 'true';
    const packName = value => /ROSA/.test(value.toUpperCase()) ? 'Barra De Rubor Pocket Rosado' : /CAF[EÉ]/.test(value.toUpperCase()) ? 'Barra De Rubor Pocket Café' : 'Barra De Rubor Pocket';
    function refreshName() {
      if (root.dataset.handle !== "rubor-en-crema-para-mejillas-y-labios-pocket-blush") return;
      const selected = root.querySelector('.product-options--root .swatch--input:checked');
      if (!selected) return;
      root.querySelectorAll('[data-tl-pack-title]').forEach(node => { const name = packName(selected.value); if (node.textContent !== name) node.textContent = name; });
    }
    root.addEventListener('change', event => { if (event.target.matches('.swatch--input')) refreshName(); });
    refreshName();
    root.querySelectorAll('[data-tl-video-open]').forEach(trigger => {
      const dialog = document.getElementById(trigger.dataset.tlVideoOpen);
      if (!dialog) return;
      trigger.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-tl-video-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { dialog.querySelectorAll('video').forEach(video => video.pause()); trigger.focus(); });
    });
    const review = root.querySelector('.tl-pdp-reviews');
    const refreshReviews = () => {
      const widget = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
      if (!widget || !review) return false;
      const count = Number(widget.dataset.numberOfReviews);
      const score = Number(widget.dataset.averageRating);
      if (!Number.isFinite(count) || !Number.isFinite(score) || score < 0 || score > 5) return false;
      review.hidden = false;
      review.querySelector('[data-tl-review-summary]').textContent = count > 0 ? `${score.toLocaleString('es-CO')} (${count} reseñas)` : 'Sin reseñas todavía';
      review.style.setProperty('--tl-rating-fill', `${score / 5 * 100}%`);
      review.setAttribute('aria-label', count > 0 ? `${score.toLocaleString('es-CO')} de 5, ${count} reseñas. Ver opiniones.` : 'Ver opiniones');
      return true;
    };
    refreshReviews();
    const reviewsObserver = new MutationObserver(refreshReviews);
    const widget = document.getElementById('judgeme_product_reviews');
    if (widget) reviewsObserver.observe(widget, {childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
    else {
      const late = new MutationObserver(() => {
        const node = document.getElementById('judgeme_product_reviews');
        if (node) { late.disconnect(); refreshReviews(); reviewsObserver.observe(node,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']}); }
      });
      late.observe(document.body,{childList:true,subtree:true});
      setTimeout(() => late.disconnect(), 30000);
    }
    const kit = root.querySelector('.tl-pdp-kit');
    if (!kit) return;
    const cards = [...kit.querySelectorAll('.tl-pdp-kit-item')];
    const button = kit.querySelector('.tl-pdp-kit-add');
    const status = kit.querySelector('.tl-pdp-kit-status');
    let busy = false;
    function selection() {
      return cards.filter(card => card.querySelector('input').checked && !card.querySelector('input').disabled).map(card => {
        const option = card.querySelector('select').selectedOptions[0];
        return option && !option.disabled ? {id:Number(option.value),quantity:1,price:Number(option.dataset.price)} : null;
      }).filter(Boolean);
    }
    function update() {
      cards.forEach(card => {
        const option = card.querySelector('select').selectedOptions[0];
        if (option) { if (card.hasAttribute('data-tl-kit-pocket')) { const name = packName(option.textContent); card.querySelector('h3').textContent = name; card.querySelector('img').alt = name; card.querySelector('input').setAttribute('aria-label', `Incluir ${name}`); card.querySelector('select').setAttribute('aria-label', `Tono de ${name}`); } card.querySelector('.tl-pdp-kit-price').textContent = money(Number(option.dataset.price)); card.querySelector('img').src = option.dataset.image; }
      });
      const items = selection();
      kit.querySelector('[data-kit-total]').textContent = money(items.reduce((total,item) => total + item.price,0));
      button.disabled = busy || items.length === 0;
    }
    kit.addEventListener('change',update);
    window.addEventListener('pageshow', event => { if (event.persisted) { busy = false; update(); button.setAttribute('aria-busy','false'); status.textContent = ''; } });
    button.addEventListener('click', async () => {
      if (busy) return;
      const items = selection().map(({id,quantity}) => ({id,quantity}));
      if (!items.length) return;
      busy = true; update(); button.setAttribute('aria-busy','true'); status.textContent = 'Añadiendo al carrito…';
      try {
        const response = await fetch(kit.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if (!response.ok) throw new Error('cart');
        await response.json();
        status.textContent = 'Kit añadido. Abriendo el carrito…';
        window.location.assign(kit.dataset.cartUrl);
      } catch (error) {
        // An ambiguous response can follow a successful add. Do not retry automatically.
        status.textContent = 'No pudimos confirmar el resultado. Revisa el carrito antes de volver a añadir el kit. ';
        const link = document.createElement('a'); link.href = kit.dataset.cartUrl; link.textContent = 'Ver carrito'; link.style.textDecoration = 'underline'; status.append(link);
        busy = false; update(); button.setAttribute('aria-busy','false');
      }
    });
    update();
  }
  const initialize = () => document.querySelectorAll('[data-tl-pdp-v2="true"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
